import { Avatar } from "@mui/material";
import { format, parseISO } from "date-fns";
import Image from "next/image";
import * as React from "react";
import "swiper/css";

export default function BlogHead({ blog }): React.ReactElement {
  const date = React.useMemo(
    () => format(parseISO(blog.date), "MMMM do, yyyy"),
    [blog.date]
  );

  return (
    <div>
      <h1 className="mb-4">{blog.title}</h1>
      <div className="flex items-center pb-6 mt-6">
        <Avatar>
          <Image
            src={blog.author.avatar}
            width={100}
            height={100}
            alt="author avatar"
            unoptimized={true}
          />
        </Avatar>
        <p className="ml-4 text-base items-center my-0 leading-5">
          By&nbsp;
          <span className="text-primary-main underline">
            {blog.author.name}
          </span>
          <span>&nbsp;on {date}</span>
          <span>
            &nbsp;• Reading Time: {Math.ceil(blog.readingTime)} minutes
          </span>
        </p>
      </div>
    </div>
  );
}
